export type PlatformEnvironmentName = 'DEV' | 'PREVIEW' | 'PRODUCTION' | 'SHOWCASE' | 'STAGE';
